export default __webpack_public_path__ + "static/cassetteLabelled_healgen-4602e359677a489900b3ec39b7602380.jpg";